/** The emojis behind "+" when reacting: common ones, in groups. */
export const EMOJI_GROUPS: Array<{ key: string; label: string; icon: string; emojis: string[] }> = [
  {
    key: 'smileys', label: 'Smileys', icon: '😀',
    emojis: ['😀', '😃', '😄', '😁', '😆', '🥹', '😊', '😇', '🙂', '😉', '😌', '😍', '🥰', '😘', '😋', '😎', '🤩', '🥳', '😏', '🤔', '🫡', '😴', '😅', '🤣', '😭', '😢', '😮', '😲', '🤯', '😳', '🥺', '😬', '🙄', '😤', '😡', '🥶'],
  },
  {
    key: 'hands', label: 'Gestures', icon: '👋',
    emojis: ['👍', '👎', '👏', '🙌', '🙏', '🤝', '👌', '✌️', '🤞', '🤙', '💪', '👋', '🫶', '🤌', '☝️', '👀'],
  },
  {
    key: 'hearts', label: 'Hearts and sparks', icon: '❤️',
    emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💔', '💕', '💯', '🔥', '✨', '⭐', '🎉', '🎊', '💫', '🌟'],
  },
  {
    key: 'trip', label: 'Food and travel', icon: '✈️',
    emojis: ['🍷', '🍻', '☕', '🍽️', '🥘', '🍰', '🍕', '🐟', '🌅', '🌊', '🏖️', '⛰️', '🚆', '✈️', '🚕', '🏛️', '🎶', '📸', '🗺️', '🏠', '🌧️', '☀️'],
  },
];

const RECENT_KEY = 'sekretly_recent_reactions';
const RECENT_MAX = 8;

export function readRecentReactions(): string[] {
  try {
    const raw = JSON.parse(window.localStorage.getItem(RECENT_KEY) ?? '[]') as unknown;
    return Array.isArray(raw) ? raw.filter((e): e is string => typeof e === 'string').slice(0, RECENT_MAX) : [];
  } catch {
    return [];
  }
}

export function rememberReaction(emoji: string) {
  try {
    const next = [emoji, ...readRecentReactions().filter((e) => e !== emoji)].slice(0, RECENT_MAX);
    window.localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {
    // Not remembering recents is fine.
  }
}
